import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 303  -  画面闪烁
 */

export default class EventFlash extends EventBase {
  /**
   * 画面闪烁的构造函数
   */
  constructor() {
    super()
    this.Parameter = ['255,255,255', '20', '']
  }

  // #region 事件内关键属性参数
  /**
   * 颜色
   */
  get Color() {
    return this.Parameter?.[0] || ''
  }
  set Color(value) {
    this.Parameter![0] = value.toString()
  }

  /**
   * 时间
   */
  get Time() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set Time(value) {
    this.Parameter![1] = value.toString()
  }
  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[2] || ''
  }
  set Description(value) {
    this.Parameter![2] = value.toString()
  }
  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.Flash

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
